var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90.699997 20.600001",
    xmlSpace: "preserve",
    inkscapeVersion: "0.91 r13725",
    sodipodiDocname: "logo.svg",
    width: 90.699997,
    height: 20.6,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style3"
  }, "\n\t.st0{fill:#134C9C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#070707;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "g5",
    transform: "translate(-5.4,-2.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 21.1,2.1 7.8,2.1 C 6.5,2.1 5.4,3.2 5.4,4.5 l 0,15.8 c 0,1.3 1.1,2.4 2.4,2.4 l 13.2,0 c 1.3,0 2.4,-1.1 2.4,-2.4 l 0,-15.8 c 0.1,-1.3 -1,-2.4 -2.3,-2.4 z m -2.6,15.2 0,0 c -0.5,0.7 -0.1,1.2 -0.1,1.4 0,0.5 -0.4,0.9 -0.9,0.9 -0.3,0 -0.6,-0.1 -0.8,-0.4 -0.2,0.2 -0.4,0.4 -0.8,0.4 -0.4,0 -0.6,-0.1 -0.8,-0.4 -0.2,0.2 -0.4,0.4 -0.8,0.4 l 0,0 0,0 c -0.3,0 -0.6,-0.1 -0.8,-0.4 -0.2,0.2 -0.4,0.4 -0.8,0.4 -0.4,0 -0.6,-0.1 -0.8,-0.4 -0.2,0.2 -0.4,0.4 -0.8,0.4 -0.5,0 -0.9,-0.4 -0.9,-0.9 0,-0.2 0.4,-0.7 -0.1,-1.4 l 0,0 C 9,15.9 8.4,14 8.4,11.9 8.4,10.5 8.8,9.1 9.3,8.1 9.4,7.9 9.5,7.7 9.7,7.5 10,7.4 10,7.3 10.1,7.3 10.5,6.9 11,6.7 11.5,6.7 c -0.1,0 -0.2,0 -0.4,0 -0.2,0 -0.4,0 -0.6,-0.1 C 10.2,6.5 9.9,6.5 9.6,6.2 9.5,6.1 9.4,6 9.3,5.8 9.2,5.6 9.1,5.3 9.1,5 9.1,4.7 9,4.4 9.1,4.1 c 0,0 0.4,0.3 0.4,0.4 0.2,0.2 0.4,0.3 0.5,0.4 0.4,0.2 0.9,0.3 1.3,0.5 0.2,0.1 0.5,0.1 0.7,0.2 0.2,0 0.4,0.1 0.5,0.1 0.3,0.1 0.6,0.1 1,0.2 0.1,0.1 0.3,0.1 0.4,0.2 0.1,0.1 0.2,0.2 0.2,0.4 0,0.2 0.1,0.4 0.1,0.6 0,0.1 0.1,0.3 0.1,0.4 0,-0.1 0,-0.3 0.1,-0.4 0,-0.2 0.1,-0.4 0.1,-0.6 0,-0.1 0.1,-0.3 0.2,-0.4 C 14.8,6 15,6 15.1,5.9 15.4,5.8 15.7,5.7 16,5.7 16.2,5.7 16.4,5.6 16.5,5.6 16.7,5.5 17,5.5 17.2,5.4 17.6,5.3 18.1,5.1 18.5,4.9 18.7,4.8 18.9,4.7 19,4.6 c 0.1,0 0.4,-0.3 0.4,-0.4 0.1,0.3 0,0.6 0,0.9 0,0.3 -0.1,0.5 -0.2,0.8 C 19.1,6 19,6.2 18.9,6.3 18.6,6.5 18.3,6.6 18,6.7 c -0.2,0 -0.4,0 -0.6,0.1 -0.1,0 -0.2,0 -0.4,0 0.5,0.1 1,0.3 1.4,0.6 0.1,0.1 0.1,0.1 0.2,0.2 0.2,0.2 0.3,0.4 0.4,0.6 0.6,1 0.9,2.4 0.9,3.8 0.4,2 -0.3,3.9 -1.4,5.3 z",
    id: "path7",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 19.6,9.6 c -0.2,1.2 -1.2,2 -2.5,2 -1.4,0 -2.5,-1.1 -2.5,-2.5 0,-1.3 1,-2.4 2.2,-2.5 -0.2,0 -0.4,0 -0.6,0 -0.4,0 -0.9,0.1 -1.3,0.3 C 14.8,7 14.7,7 14.6,7.2 14.5,7.3 14.4,7.4 14.4,7.5 14.4,7.4 14.3,7.3 14.2,7.2 14.1,7.1 14,7 13.9,6.9 13.5,6.7 13,6.7 12.6,6.6 c -0.2,0 -0.4,0 -0.6,0 1.3,0.1 2.2,1.2 2.2,2.5 0,1.4 -1.1,2.5 -2.5,2.5 -1.2,0 -2.2,-0.9 -2.5,-2 0,0.4 -0.1,0.9 -0.1,1.4 0,3.6 3.5,7.1 5.1,7.1 l 0.1,0 0.1,0 c 1.6,-0.1 5.1,-3.6 5.1,-7.2 0.1,-0.4 0.1,-0.8 0.1,-1.3 z m -5.2,3.3 c -0.1,0 -0.9,-1.5 -0.9,-1.6 0,-0.1 0.7,-0.6 0.9,-0.6 0.2,0 0.9,0.5 0.9,0.6 0.1,0.1 -0.8,1.6 -0.9,1.6 z",
    id: "path9",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 10.9,10 c 0,0.4 0.4,0.8 0.8,0.8 0.4,0 0.8,-0.4 0.8,-0.8 0,-0.4 -0.4,-0.8 -0.8,-0.8 -0.4,0 -0.8,0.3 -0.8,0.8",
    id: "path11",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 17.3,9.2 c -0.4,0 -0.8,0.4 -0.8,0.8 0,0.4 0.4,0.8 0.8,0.8 0.4,0 0.8,-0.4 0.8,-0.8 0,-0.5 -0.3,-0.8 -0.8,-0.8",
    id: "path13",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 27.6,14.4 0,-10.7 5.8,0 0,1.7 -3.8,0 0,2.8 3.6,0 0,1.7 -3.6,0 0,2.8 3.9,0 0,1.7 -5.9,0 z",
    id: "path21",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 37.3,14.6 c -1.1,0 -2.1,-0.5 -2.7,-1.1 l 1.1,-1.1 c 0.3,0.3 0.9,0.6 1.6,0.6 0.8,0 1.2,-0.4 1.2,-0.8 0,-1.5 -3.7,-0.7 -3.7,-3.5 0,-1.1 1,-2.3 2.9,-2.3 1.1,0 2,0.4 2.6,1.1 l -1,1.2 C 38.9,8.3 38.4,8.1 37.8,8.1 c -0.7,0 -1.1,0.4 -1.1,0.8 0,1.2 3.7,0.6 3.7,3.5 0,1 -1,2.2 -3.1,2.2 z",
    id: "path23",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 45,14.5 c -1.5,0 -2.4,-1 -2.4,-2.1 l 0,-4.1 -1.4,0 0,-1.6 1.4,0 0,-2.2 1.9,0 0,2.2 1.8,0 0,1.5 -1.8,0 0,3.9 c 0,0.6 0.3,0.9 1,0.9 0.3,0 0.6,-0.1 0.9,-0.1 l 0,1.5 c -0.4,0 -0.9,0.1 -1.4,0.1 z",
    id: "path25",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 51.2,8.3 c -0.9,0.2 -1.4,1 -1.4,2.3 l 0,3.8 -1.9,0 0,-7.7 1.8,0 0,1.2 c 0.4,-0.8 1.2,-1.3 2.7,-1.3 l 0,1.7 C 52,8.2 51.5,8.2 51.2,8.3 Z",
    id: "path27",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 58.1,14.4 0,-1.2 c -0.4,0.8 -1.2,1.3 -2.3,1.3 -1.4,0 -2.5,-1 -2.5,-2.2 0,-1.3 1.1,-2.5 3.6,-2.5 l 1.2,0 c 0,-0.1 0,-0.6 0,-0.6 C 58,8.6 57.4,8 56.5,8 55.8,8 55.2,8.3 54.8,8.6 L 53.7,7.5 c 0.7,-0.6 1.7,-1.1 3,-1.1 2.1,0 3.3,1.2 3.3,2.8 l 0,5 -1.9,0.2 0,0 z m 0,-3.4 -1.3,0 c -1.1,0 -1.6,0.6 -1.6,1.1 0,0.5 0.4,1 1.2,1 1,0 1.7,-0.7 1.7,-1.9 l 0,-0.2 0,0 z",
    id: "path29",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 65.2,14.5 c -1.5,0 -2.4,-1 -2.4,-2.1 l 0,-4.1 -1.4,0 0,-1.6 1.4,0 0,-2.2 1.9,0 0,2.2 1.8,0 0,1.5 -1.8,0 0,3.9 c 0,0.6 0.3,0.9 1,0.9 0.3,0 0.6,-0.1 0.9,-0.1 l 0,1.5 c -0.4,0 -0.8,0.1 -1.4,0.1 z",
    id: "path31",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 69.5,11.1 c 0.2,1.2 0.9,2 2.1,2 0.6,0 1.2,-0.2 1.5,-0.6 l 1.1,1.1 c -0.8,0.7 -1.6,1 -2.7,1 -2.3,0 -4,-1.6 -4,-4 0,-2.4 1.5,-4 3.6,-4 2,0 3.5,1.4 3.5,4.1 l 0,0.4 -5.1,0 0,0 z M 71.2,8 c -0.8,0 -1.5,0.7 -1.6,1.7 l 3.2,0 C 72.6,8.7 72.1,8 71.2,8 Z m 0,-2 -1.1,0 1,-2.5 2.1,0 -2,2.5 z",
    id: "path33",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 79.2,17.2 c -1.5,0 -2.5,-0.5 -3,-1.1 L 77.3,15 c 0.4,0.4 1,0.7 1.9,0.7 1.3,0 2.2,-0.8 2.2,-2 l 0,-0.6 c -0.4,0.7 -1.3,1.2 -2.2,1.2 -1.8,0 -3.4,-1.5 -3.4,-3.9 0,-2.3 1.6,-3.9 3.4,-3.9 1,0 2,0.6 2.3,1.3 l 0,-1.1 1.8,0 0,7 c -0.1,1.9 -1.6,3.5 -4.1,3.5 z m 0.4,-9.1 c -1,0 -1.8,0.9 -1.8,2.3 0,1.4 0.8,2.3 1.8,2.3 1,0 1.8,-0.9 1.8,-2.3 0,-1.4 -0.8,-2.3 -1.8,-2.3 z",
    id: "path35",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 85.6,5.5 0,-1.8 1.9,0 0,1.8 -1.9,0 z m 0,8.9 0,-7.7 1.9,0 0,7.7 -1.9,0 z",
    id: "path37",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 94.2,14.4 0,-1.2 c -0.4,0.8 -1.2,1.3 -2.3,1.3 -1.4,0 -2.5,-1 -2.5,-2.2 0,-1.3 1.1,-2.5 3.6,-2.5 l 1.2,0 c 0,-0.1 0,-0.6 0,-0.6 C 94.1,8.6 93.5,8 92.6,8 91.9,8 91.3,8.3 90.9,8.6 L 89.8,7.5 c 0.7,-0.6 1.7,-1.1 3,-1.1 2.1,0 3.3,1.2 3.3,2.8 l 0,5 -1.9,0.2 0,0 z M 94.1,11 92.8,11 c -1.1,0 -1.6,0.6 -1.6,1.1 0,0.5 0.4,1 1.2,1 1,0 1.7,-0.7 1.7,-1.9 l 0,-0.2 0,0 z",
    id: "path39",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#ffffff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 27.6,14.4 0,-10.7 5.8,0 0,1.7 -3.8,0 0,2.8 3.6,0 0,1.7 -3.6,0 0,2.8 3.9,0 0,1.7 -5.9,0 z",
    id: "path43",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 37.3,14.6 c -1.1,0 -2.1,-0.5 -2.7,-1.1 l 1.1,-1.1 c 0.3,0.3 0.9,0.6 1.6,0.6 0.8,0 1.2,-0.4 1.2,-0.8 0,-1.5 -3.7,-0.7 -3.7,-3.5 0,-1.1 1,-2.3 2.9,-2.3 1.1,0 2,0.4 2.6,1.1 l -1,1.2 C 38.9,8.3 38.4,8.1 37.8,8.1 c -0.7,0 -1.1,0.4 -1.1,0.8 0,1.2 3.7,0.6 3.7,3.5 0,1 -1,2.2 -3.1,2.2 z",
    id: "path45",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 45,14.5 c -1.5,0 -2.4,-1 -2.4,-2.1 l 0,-4.1 -1.4,0 0,-1.6 1.4,0 0,-2.2 1.9,0 0,2.2 1.8,0 0,1.5 -1.8,0 0,3.9 c 0,0.6 0.3,0.9 1,0.9 0.3,0 0.6,-0.1 0.9,-0.1 l 0,1.5 c -0.4,0 -0.9,0.1 -1.4,0.1 z",
    id: "path47",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 51.2,8.3 c -0.9,0.2 -1.4,1 -1.4,2.3 l 0,3.8 -1.9,0 0,-7.7 1.8,0 0,1.2 c 0.4,-0.8 1.2,-1.3 2.7,-1.3 l 0,1.7 C 52,8.2 51.5,8.2 51.2,8.3 Z",
    id: "path49",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 58.1,14.4 0,-1.2 c -0.4,0.8 -1.2,1.3 -2.3,1.3 -1.4,0 -2.5,-1 -2.5,-2.2 0,-1.3 1.1,-2.5 3.6,-2.5 l 1.2,0 c 0,-0.1 0,-0.6 0,-0.6 C 58,8.6 57.4,8 56.5,8 55.8,8 55.2,8.3 54.8,8.6 L 53.7,7.5 c 0.7,-0.6 1.7,-1.1 3,-1.1 2.1,0 3.3,1.2 3.3,2.8 l 0,5 -1.9,0.2 0,0 z m 0,-3.4 -1.3,0 c -1.1,0 -1.6,0.6 -1.6,1.1 0,0.5 0.4,1 1.2,1 1,0 1.7,-0.7 1.7,-1.9 l 0,-0.2 0,0 z",
    id: "path51",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 65.2,14.5 c -1.5,0 -2.4,-1 -2.4,-2.1 l 0,-4.1 -1.4,0 0,-1.6 1.4,0 0,-2.2 1.9,0 0,2.2 1.8,0 0,1.5 -1.8,0 0,3.9 c 0,0.6 0.3,0.9 1,0.9 0.3,0 0.6,-0.1 0.9,-0.1 l 0,1.5 c -0.4,0 -0.8,0.1 -1.4,0.1 z",
    id: "path53",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 69.5,11.1 c 0.2,1.2 0.9,2 2.1,2 0.6,0 1.2,-0.2 1.5,-0.6 l 1.1,1.1 c -0.8,0.7 -1.6,1 -2.7,1 -2.3,0 -4,-1.6 -4,-4 0,-2.4 1.5,-4 3.6,-4 2,0 3.5,1.4 3.5,4.1 l 0,0.4 -5.1,0 0,0 z M 71.2,8 c -0.8,0 -1.5,0.7 -1.6,1.7 l 3.2,0 C 72.6,8.7 72.1,8 71.2,8 Z m 0,-2 -1.1,0 1,-2.5 2.1,0 -2,2.5 z",
    id: "path55",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 79.2,17.2 c -1.5,0 -2.5,-0.5 -3,-1.1 L 77.3,15 c 0.4,0.4 1,0.7 1.9,0.7 1.3,0 2.2,-0.8 2.2,-2 l 0,-0.6 c -0.4,0.7 -1.3,1.2 -2.2,1.2 -1.8,0 -3.4,-1.5 -3.4,-3.9 0,-2.3 1.6,-3.9 3.4,-3.9 1,0 2,0.6 2.3,1.3 l 0,-1.1 1.8,0 0,7 c -0.1,1.9 -1.6,3.5 -4.1,3.5 z m 0.4,-9.1 c -1,0 -1.8,0.9 -1.8,2.3 0,1.4 0.8,2.3 1.8,2.3 1,0 1.8,-0.9 1.8,-2.3 0,-1.4 -0.8,-2.3 -1.8,-2.3 z",
    id: "path57",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 85.6,5.5 0,-1.8 1.9,0 0,1.8 -1.9,0 z m 0,8.9 0,-7.7 1.9,0 0,7.7 -1.9,0 z",
    id: "path59",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 94.2,14.4 0,-1.2 c -0.4,0.8 -1.2,1.3 -2.3,1.3 -1.4,0 -2.5,-1 -2.5,-2.2 0,-1.3 1.1,-2.5 3.6,-2.5 l 1.2,0 c 0,-0.1 0,-0.6 0,-0.6 C 94.1,8.6 93.5,8 92.6,8 91.9,8 91.3,8.3 90.9,8.6 L 89.8,7.5 c 0.7,-0.6 1.7,-1.1 3,-1.1 2.1,0 3.3,1.2 3.3,2.8 l 0,5 -1.9,0.2 0,0 z M 94.1,11 92.8,11 c -1.1,0 -1.6,0.6 -1.6,1.1 0,0.5 0.4,1 1.2,1 1,0 1.7,-0.7 1.7,-1.9 l 0,-0.2 0,0 z",
    id: "path61",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#134c9c"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 29.4,21.2 c -1.1,0 -1.8,-0.8 -1.8,-2 0,-1.2 0.7,-2 1.8,-2 0.5,0 0.9,0.2 1.2,0.5 L 30.3,18 c -0.3,-0.2 -0.5,-0.4 -0.9,-0.4 -0.8,0 -1.3,0.6 -1.3,1.6 0,1 0.6,1.6 1.3,1.6 0.4,0 0.6,-0.1 0.9,-0.4 l 0.3,0.3 c -0.3,0.3 -0.7,0.5 -1.2,0.5 z",
    id: "path65",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#070707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 34.6,21.2 c -1,0 -1.7,-0.8 -1.7,-2 0,-1.2 0.7,-2 1.7,-2 1,0 1.7,0.8 1.7,2 0.1,1.2 -0.7,2 -1.7,2 z m 0,-3.6 c -0.7,0 -1.2,0.6 -1.2,1.6 0,1 0.6,1.6 1.2,1.6 0.7,0 1.2,-0.6 1.2,-1.6 0.1,-1 -0.5,-1.6 -1.2,-1.6 z",
    id: "path67",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#070707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 41.1,21.1 -1.7,-3.3 0,3.3 -0.4,0 0,-3.9 0.7,0 1.7,3.3 0,-3.3 0.5,0 0,3.9 c -0.1,0 -0.8,0 -0.8,0 z",
    id: "path69",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#070707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 46.3,21.2 c -1.1,0 -1.8,-0.8 -1.8,-2 0,-1.2 0.7,-2 1.8,-2 0.5,0 0.9,0.2 1.2,0.5 L 47.2,18 c -0.3,-0.2 -0.5,-0.4 -0.9,-0.4 -0.8,0 -1.3,0.6 -1.3,1.6 0,1 0.6,1.6 1.3,1.6 0.4,0 0.6,-0.1 0.9,-0.4 l 0.3,0.3 c -0.3,0.3 -0.7,0.5 -1.2,0.5 z",
    id: "path71",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#070707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M 51.4,21.2 C 50.7,21.2 50,20.8 50,19.9 l 0,-2.7 0.5,0 0,2.7 c 0,0.6 0.4,0.9 0.9,0.9 0.5,0 0.9,-0.3 0.9,-0.9 l 0,-2.7 0.5,0 0,2.7 c 0,0.9 -0.7,1.3 -1.4,1.3 z",
    id: "path73",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#070707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M 57.8,21.1 57.5,19.8 C 57.4,19.5 57.3,19.4 57,19.4 l -0.9,0 0,1.8 -0.5,0 0,-3.9 1.4,0 c 0.8,0 1.2,0.4 1.2,1 0,0.4 -0.3,0.8 -0.7,0.9 0.3,0 0.5,0.3 0.6,0.6 l 0.3,1.4 c -0.1,-0.1 -0.6,-0.1 -0.6,-0.1 z m -0.8,-3.5 -0.8,0 0,1.3 0.7,0 c 0.5,0 0.8,-0.3 0.8,-0.7 0,-0.3 -0.2,-0.6 -0.7,-0.6 z",
    id: "path75",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#070707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 61.8,21.2 c -0.6,0 -1,-0.3 -1.2,-0.5 l 0.3,-0.3 c 0.2,0.2 0.6,0.4 0.9,0.4 0.5,0 0.8,-0.3 0.8,-0.7 0,-0.3 -0.3,-0.5 -0.6,-0.7 l -0.6,-0.2 c -0.4,-0.1 -0.8,-0.4 -0.8,-1 0,-0.5 0.4,-1.1 1.3,-1.1 0.5,0 0.9,0.2 1.2,0.5 l -0.3,0.3 c -0.2,-0.2 -0.5,-0.4 -0.9,-0.4 -0.5,0 -0.8,0.3 -0.8,0.6 0,0.3 0.2,0.5 0.5,0.6 l 0.6,0.2 c 0.5,0.1 0.9,0.4 0.9,1.1 0,0.7 -0.5,1.2 -1.3,1.2 z",
    id: "path77",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#070707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 67.2,21.2 c -1,0 -1.7,-0.8 -1.7,-2 0,-1.2 0.7,-2 1.7,-2 1,0 1.7,0.8 1.7,2 0.1,1.2 -0.7,2 -1.7,2 z m 0,-3.6 c -0.7,0 -1.2,0.6 -1.2,1.6 0,1 0.6,1.6 1.2,1.6 0.7,0 1.2,-0.6 1.2,-1.6 0.1,-1 -0.5,-1.6 -1.2,-1.6 z",
    id: "path79",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#070707"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 72.6,21.2 c -0.6,0 -1,-0.3 -1.2,-0.5 l 0.3,-0.3 c 0.2,0.2 0.6,0.4 0.9,0.4 0.5,0 0.8,-0.3 0.8,-0.7 0,-0.3 -0.3,-0.5 -0.6,-0.7 l -0.5,-0.2 c -0.4,-0.1 -0.8,-0.4 -0.8,-1 0,-0.5 0.4,-1.1 1.3,-1.1 0.5,0 0.9,0.2 1.2,0.5 l -0.3,0.3 c -0.2,-0.2 -0.5,-0.4 -0.9,-0.4 -0.5,0 -0.8,0.3 -0.8,0.6 0,0.3 0.2,0.5 0.5,0.6 l 0.6,0.2 c 0.5,0.1 0.9,0.4 0.9,1.1 -0.1,0.7 -0.7,1.2 -1.4,1.2 z",
    id: "path81",
    "inkscapeConnector-curvature": 0,
    style: {
      fill: "#070707"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3baf9fde3672f469ca6fe1cc6d8428e5.svg";
export { ForwardRef as ReactComponent };